import './src/scss/fonts.scss';

import RiseupButton from './src/components/RiseupButton.vue';
import ClosedCard from './src/components/ClosedCard.vue';
import Card from './src/components/Card.vue';
import RiseupBot from './src/components/RiseupBot.vue';
import Popup from './src/components/Popup.vue';
import ColoredPopup from './src/components/ColoredPopup.vue';
import ColoredLinePopup from './src/components/ColoredLinePopup.vue';
import CashflowCategoryDropdown from './src/components/CashflowCategoryDropdown.vue';
import EditAmountInput from './src/components/EditAmountInput.vue';
import PlainDropdown from './src/components/PlainDropdown.vue';
import TextInput from './src/components/TextInput.vue';
import SupportFooter from './src/components/SupportFooter.vue';
import LoginSupportFooter from './src/components/LoginSupportFooter.vue';
import Separator from './src/components/Separator.vue';
import NumberedBullet from './src/components/NumberedBullet.vue';
import SnackBar from './src/components/SnackBar.vue';
import WebShare from './src/components/WebShare.vue';
import TinyLoader from './src/components/TinyLoader.vue';
import AnimatedNumber from './src/components/AnimatedNumber.vue';
import CollapseTransition from './src/components/CollapseTransition.vue';
import VideoPlayer from './src/components/VideoPlayer.vue';
import AnimatedLoader from './src/components/AnimatedLoader.vue';
import TextArea from './src/components/TextArea.vue';
import Callout from './src/components/Callout.vue';
import Icon from './src/components/Icon.vue';
import Signature from './src/components/Signature.vue';
import DefaultTextInput from './src/components/DefaultTextInput.vue';
import AmountInput from './src/components/AmountInput.vue';
import installPlugins from './src/plugins';

// eslint-disable-next-line max-len
const components = [RiseupButton, ClosedCard, Card, RiseupBot, Popup, ColoredPopup, ColoredLinePopup, CashflowCategoryDropdown, EditAmountInput, PlainDropdown, TextInput, SupportFooter, LoginSupportFooter, Separator, NumberedBullet, SnackBar, WebShare, TinyLoader, AnimatedNumber, CollapseTransition, VideoPlayer, AnimatedLoader, Callout, Icon, Signature, DefaultTextInput, AmountInput];

const init = Vue => {
  components.forEach(component => {
    Vue.component(component.name, component);
  });
};

function install(app) {
  installPlugins(app);
}

export default {
  init,
  install,
  RiseupButton,
  ClosedCard,
  Card,
  RiseupBot,
  Popup,
  ColoredPopup,
  ColoredLinePopup,
  CashflowCategoryDropdown,
  EditAmountInput,
  PlainDropdown,
  TextInput,
  TextArea,
  SupportFooter,
  LoginSupportFooter,
  Separator,
  NumberedBullet,
  SnackBar,
  WebShare,
  TinyLoader,
  AnimatedNumber,
  CollapseTransition,
  VideoPlayer,
  AnimatedLoader,
  Callout,
  Icon,
  Signature,
  DefaultTextInput,
  AmountInput,
};
